export default __webpack_public_path__ + "arrow_down.54912d2b219e0035420bb3fd811f65cf.png";